import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = { class: "sorting" }
const _hoisted_3 = { class: "hiding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.activeMain = !$setup.activeMain))
      }, "Sort By: " + _toDisplayString($setup.activeMain ? "Date" : "Name"), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.activeThree = !$setup.activeThree))
      }, "Order: " + _toDisplayString($setup.activeThree ? "Descending" : "Ascending"), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: _normalizeClass(["hidden", {active:$setup.isActive}]),
        onClick: $setup.showHidden
      }, "Show Hidden", 2)
    ])
  ]))
}